import * as XLSX from "xlsx";

export const exportCardsToXlsx = (cards, name) => {
  if (!cards || cards.length === 0) {
    //console.log("No cards available to export.");
    return;
  }

  const data = cards.map((card) => ({
    "List Name": card.listName,
    "Card Name": card.name,
    "Card Description": card.desc || "",
    Labels: card.labels,
    Members: card.members,
    "Due Date": card.due || "",
    "Start Date": card.startDate || "",
  }));

  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, name);

  XLSX.writeFile(wb, name + ".xlsx");
};

export const exportCardsToCSV = (cards, name) => {
  const convertToCSV = (data) => {
    const header = [
      "List Name",
      "Card Name",
      "Card Description",
      "Labels",
      "Members",
      "Due Date",
      "Start Date",
    ];

    const rows = data.map((card) => [
      card.name,
      card.desc || "",
      card.labels ? card.labels.join("; ") : "",
      card.members ? card.members.join("; ") : "",
      card.due || "",
      card.startDate || "",
      card.listName,
    ]);

    const csvContent = [
      header.join(","),
      ...rows.map((row) => row.join(",")),
    ].join("\n");

    return csvContent;
  };

  if (!cards || cards.length === 0) {
    //console.log("No cards available to export.");
    return;
  }

  const csvContent = convertToCSV(cards);

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

  const link = document.createElement("a");
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", name + ".csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const hours = [
  "00:00",
  "00:30",
  "01:00",
  "01:30",
  "02:00",
  "02:30",
  "03:00",
  "03:30",
  "04:00",
  "04:30",
  "05:00",
  "05:30",
  "06:00",
  "06:30",
  "07:00",
  "07:30",
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",
  "18:30",
  "19:00",
  "19:30",
  "20:00",
  "20:30",
  "21:00",
  "21:30",
  "22:00",
  "22:30",
  "23:00",
  "23:30",
];

export function abbreviateDay(day) {
  const daysAbbreviations = {
      sunday: "Sun",
      monday: "Mon",
      tuesday: "Tue",
      wednesday: "Wed",
      thursday: "Thu",
      friday: "Fri",
      saturday: "Sat",
  };
  return daysAbbreviations[day.toLowerCase()] || "Invalid day";
}

export function countScheduledHours(agendaGetViewModels) {
  if (!Array.isArray(agendaGetViewModels)) {
      throw new Error("O parâmetro deve ser um array.");
  }

  return agendaGetViewModels.reduce((total, agenda) => {
      if (Array.isArray(agenda.agendaEscalaGetViewModels)) {
          return total + agenda.agendaEscalaGetViewModels.length;
      }
      return total;
  }, 0);
}

export function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export const allMonths = [
  { name: "january", value: 1 },
  { name: "february", value: 2 },
  { name: "march", value: 3 },
  { name: "april", value: 4 },
  { name: "may", value: 5 },
  { name: "june", value: 6 },
  { name: "july", value: 7 },
  { name: "august", value: 8 },
  { name: "september", value: 9 },
  { name: "october", value: 10 },
  { name: "november", value: 11 },
  { name: "december", value: 12 },
];
